import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Disconnect from "./Disconnect";


export default function PanelMenu(props){
    const location = useLocation();
    const path = location.pathname;

    useEffect(()=>{
        const current = path.replace('/', '');
        const links = document.getElementById('nav-admin').getElementsByTagName('a');
        for(let i = 0; i < links.length; i++){
            if(links[i].id == current){
                links[i].classList = "current";
            }else{
                links[i].classList = "";
            }
        }
    },[path]);

    return(
        <nav id="nav-admin">
            <Link id="accueil" to="/accueil">Accueil</Link>
            <Link id="extraits" to="/extraits">Extrait</Link>
            <Link id="gallerie" to="/gallerie">Gallerie</Link>
            <Link id="setlist" to="/setlist">Setlist</Link>
            <Link id="zoom" to="/zoom">Zoom</Link>
            <Disconnect login={()=>props.login()} />
        </nav>
    );
}

